var map = {
	"./driver-assigned/driver-assigned.module": [
		"./src/app/driver-assigned/driver-assigned.module.ts",
		"driver-assigned-driver-assigned-module"
	],
	"./error/error.module": [
		"./src/app/error/error.module.ts",
		"error-error-module"
	],
	"./loading/loading.module": [
		"./src/app/loading/loading.module.ts",
		"loading-loading-module"
	],
	"./looking-for-driver/looking-for-driver.module": [
		"./src/app/looking-for-driver/looking-for-driver.module.ts",
		"looking-for-driver-looking-for-driver-module"
	],
	"./thank-you/thank-you.module": [
		"./src/app/thank-you/thank-you.module.ts",
		"thank-you-thank-you-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;